import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0.794189 12.3676L11.9202 23.4937L16.4088 19.0051L5.28306 7.87939L0.794189 12.3676Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.823 17.5909L21.4276 13.9862L18.595 11.1536L21.8695 7.87928L16.4087 2.41846L13.1342 5.69282L10.3016 2.86019L6.69694 6.46485L17.823 17.5909Z"}}]};

const BrushFilled = Vue.extend<IconProps>({
  name: 'BrushFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'brush-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BrushFilled;
